const tileListViewLayout = Object.freeze({
    TILE_VIEW: 'Tile',
    LIST_VIEW: 'List',
});

module.exports = {
    tileListViewLayout,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/tile-list-view-layout.constants.js